export default __webpack_public_path__ + "static/IKC-Logo-cc294634c4cb4387a8eead03bd009142.jpg";